import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import NotFound from 'srcReact/components/common2/NotFound'
import useInfinitScroll from 'srcReact/helpers/hooks/useInfinitScroll'
import { mixrActions } from 'srcReact/Mixr/actions'
import Info from './components/Info'
import NewFeed from 'srcReact/components/common2/NewFeed'
import styles from './styles.module.scss'
import FeedsTabContent from 'srcReact/components/common2/FeedsTabContent'
import Spinner from 'srcReact/components/common2/Spinner'
import { commonActions } from 'srcReact/components'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import Button from 'srcReact/components/common2/Button'
import { getCurrentS3Url, openInNewTab } from 'srcReact/helpers/utils'
import Icon from 'srcReact/components/icons/Icon'
import { commonFeedActions } from 'srcReact/components/common2/FeedsTabContent/actions'
import PendingMessageCount from 'srcReact/components/common2/FeedsTabContent/components/PendingMessageCount'
import MixrGroupListItem from 'srcReact/components/common2/MixrGroupListItem'
import AnchorLink from 'srcReact/components/common2/AnchorLink'
import MixrRating from '../MixrRating'
import RateMixrModal from '../MixrRating/components/RateMixrModal'

export default function Feeds({
  mixrId,
  isGroupVisible,
  isMemberOfGroup,
  isGroupOrganizer,
  isMixrOrganizer,
  feedIdToScroll,
  isGoing,
  setFeedIdToScroll,
  isStatic = false,
  isDesktop,
  handleAddToCalendar
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [pagination, setPagination] = useState({
    nextOffset: 0,
    isPagination: false
  })
  const [pendingMessgeCount, setPendingMessgeCount] = useState(0)
  const [apiTriggeredForNewContent, setApiTriggeredForNewContent] = useState(false)

  const [files, setFiles] = useState([])
  const {
    login: { user: loggedInUser },
    common: { isMobile, isNative, tagUsersList },
    organization: {
      header: { newsfeed }
    },
    commonNewsfeed: {
      newsFeedId,
      feeds: { list, stats, loading: loadingFeeds, success: loadedFeeds },
      scrollToPost
    },
    mixr: { mixr, rating }
  } = useSelector((state) => state)

  useEffect(() => {
    if (mixr && !isStatic) {
      dispatch(commonFeedActions.getFeeds('mixr', mixrId, pagination, false))
    }
  }, [])
  useEffect(() => {
    if (mixr && mixr.group && mixr.group.id > 0) {
      dispatch(commonActions.getTagUsers('group', mixr && mixr.group && mixr.group.id))
    }
  }, [mixr && mixr.group && mixr.group.id])

  useEffect(() => {
    if (newsfeed?.new_content === 1) {
      dispatch(commonFeedActions.getFeeds('mixr', mixrId, pagination, true))
      setApiTriggeredForNewContent(true)
    } else if (newsfeed?.background_message_posting_count > 0) {
      //this reducer data (newsfeedid and count) will be used file modal if open
      dispatch(commonFeedActions.setPendingMessageCount(newsFeedId, newsfeed.background_message_posting_count))
      setPendingMessgeCount(newsfeed.background_message_posting_count)
    } else {
      dispatch(commonFeedActions.setPendingMessageCount(newsFeedId, 0))
      setPendingMessgeCount(0)
    }
  }, [newsfeed?.new_content, newsfeed?.background_message_posting_count])

  useEffect(() => {
    // once newsfeed list is loaded(after called on organization.header.newsfeed.new_content becoming 1),
    // set pending message count to background_message_posting_count
    if (loadedFeeds && apiTriggeredForNewContent) {
      setApiTriggeredForNewContent(false)
      setPendingMessgeCount(newsfeed?.background_message_posting_count)
      dispatch(commonFeedActions.setPendingMessageCount(newsFeedId, newsfeed?.background_message_posting_count))
    }
  }, [loadedFeeds, apiTriggeredForNewContent, newsfeed?.background_message_posting_count])

  const getCurrentQuantity = () => {
    return stats.nextOffset < appConstantSettings.PAGINATION_QUANTITY
      ? appConstantSettings.PAGINATION_QUANTITY
      : stats.nextOffset
  }

  const lastFeedRef = useInfinitScroll(
    loadingFeeds,
    stats && stats.remaining,
    stats && stats.nextOffset,
    setPagination,
    [loadingFeeds, stats]
  )

  useEffect(() => {
    if (scrollToPost.newsfeed_id > 0 && scrollToPost.post_id > 0 && scrollToPost.content_offset > 0) {
      setPagination({ nextOffset: scrollToPost.content_offset, isPagination: true })
    }
  }, [scrollToPost])
  useEffect(() => {
    if (mixr && pagination.isPagination) {
      dispatch(commonFeedActions.getFeeds('mixr', mixrId, pagination, false))
    }
  }, [dispatch, pagination])

  const deleteFile = (messageId, fileId) => {
    dispatch(mixrActions.deleteFileFromMessage(messageId, fileId, getCurrentQuantity()))
  }

  const handleAddCoorganizer = (userId) => {
    if (mixr) {
      dispatch(mixrActions.addStaffRole(mixrId, userId, 'co-organizer'))
    }
  }
  const handleRemoveCoorganizer = (userId) => {
    if (mixr) {
      dispatch(mixrActions.removeStaffRole(mixrId, userId, 'staff'))
    }
  }

  const renderFees = (fees) => {
    let higherPrice = fees[0]
    if (fees.length === 1) {
      return `${higherPrice.amount}${higherPrice.currency_symbol}`
    }
    return `${higherPrice.amount}${higherPrice.currency_symbol} | +`
  }

  const handleFeesClick = (link) => {
    if (link) openInNewTab(link)
  }

  return (
    <div id='feedWrapper' className={styles.feedsWrapper}>
      {mixr?.group && (
        <AnchorLink
          className={`${styles.groupContainerLink} ${isStatic && styles.staticGroupContainerLink}`}
          path={isStatic ? `/0/home/group/${mixr.group.id}` : ''}>
          <MixrGroupListItem
            id={mixr.group.id}
            picture={mixr.group.picture?.url}
            title={mixr.group.name || mixr.group.group_name}
            className={styles.groupContainer}
            titleCSS={styles.groupName}
            type='group'
            renderCustomAction={() => <Icon name='arrow-right' size='large24' />}
          />
        </AnchorLink>
      )}
      {mixr.status === 'over' && rating.data && mixr && (
        <MixrRating
          mixrData={mixr}
          ratingData={rating.data}
          loading={rating.loading}
          error={rating.error}
          success={rating.success}
          isMobileDevice={isMobile || isNative}
          loggedUserId={loggedInUser.id}
        />
      )}

      <Info
        t={t}
        isMemberOfGroup={isMemberOfGroup}
        address={mixr && mixr.location}
        description={mixr && mixr.description}
        isGoing={isGoing}
        isStatic={isStatic}
      />
      {isMobile && !isDesktop && (
        <div className={`${styles.ctaButtons}  ${isStatic && styles.inactiveButton}`}>
          {mixr && mixr.status !== 'over' && isGoing && (
            <Button
              customStyle={`${styles.calendarBtn}`}
              text={t('mixrHome.calendar')}
              size='large'
              iconPosition='start'
              icon={<Icon name='create-mixr' size='large32' />}
              icon2={<Icon name='arrow-right' size='large32' />}
              handleClick={() => !isStatic && handleAddToCalendar()}
            />
          )}
          {mixr && mixr.pricing_type === 'with_fees' && mixr.fees && mixr.fees.length >= 1 && (
            <Button
              text={renderFees(mixr.fees)}
              customStyle={styles.priceBtn}
              size='large'
              iconPosition='start'
              icon={<Icon name='price-icon' size='large32' />}
              icon2={<Icon name='arrow-right' size='large32' />}
              {...(mixr.fees[0].link ? { icon2: <Icon name='arrow-right' size='large32' /> } : {})}
              handleClick={() => handleFeesClick(mixr.fees[0].link)}
            />
          )}
          {mixr && mixr.join_in_link && (
            <Button
              customStyle={styles.joinBtn}
              text={t('mixrHome.join')}
              size='large'
              iconPosition='start'
              icon={<Icon name='virtualmixr-icon' size='large32' />}
              icon2={<Icon name='arrow-right' size='large32' />}
              handleClick={() => openInNewTab(mixr.join_in_link)}
            />
          )}
        </div>
      )}
      {isGroupVisible && isMemberOfGroup && !isStatic && (
        <NewFeed
          type='mixr'
          entity={mixr && { type: 'mixr', id: mixrId, name: mixr.name, picture: mixr.picture, groupId: mixr.group.id }}
          isStatic={isStatic}
        />
      )}
      {!loadingFeeds && pendingMessgeCount > 0 && <PendingMessageCount from='feed' count={pendingMessgeCount} />}
      {mixr?.status === 'cancelled' && (
        <NotFound className={styles.notFoundContainer} title={t('mixrHome.cancelledMixrText')} />
      )}
      {!isStatic ? (
        !isGroupVisible ? (
          <NotFound
            className={styles.notFoundContainer}
            icon='mask-noBounding'
            {...(mixr && mixr.logged_user && mixr.logged_user.group_attending === 'none'
              ? {
                  button: t('mixrHome.requestToJoin'),
                  handleClick: () => {
                    if (mixr && mixr.group.id > 0 && mixr.logged_user) {
                      dispatch(mixrActions.joinGroup(mixr.group.id, mixr.logged_user.invited_by))
                    }
                  }
                }
              : null)}
            title={t('mixrHome.privateMixrText')}
          />
        ) : loadingFeeds && !pagination.isPagination ? (
          <Spinner />
        ) : !loadingFeeds && list && list.length === 0 ? (
          <NotFound
            title={t('mixrHome.feeds.noPost')}
            //  button={t('mixrHome.feeds.btnWritePost')}
          />
        ) : (
          <React.Fragment>
            <FeedsTabContent
              type='mixr'
              entity={
                mixr && { type: 'mixr', id: mixrId, name: mixr.name, picture: mixr.picture, groupId: mixr.group.id }
              }
              isMember={isMemberOfGroup}
              lastFeedRef={lastFeedRef}
              isGroupOrganizer={isGroupOrganizer}
              isOrganizer={isMixrOrganizer}
              isMixrOver={mixr && mixr.status === 'over'}
              handleAddCoorganizer={handleAddCoorganizer}
              handleRemoveCoorganizer={handleRemoveCoorganizer}
              totalUsers={tagUsersList}
              feedIdToScroll={feedIdToScroll}
              setFeedIdToScroll={setFeedIdToScroll}
              isStatic={isStatic}
            />
            {loadingFeeds && pagination.isPagination && <Spinner />}
          </React.Fragment>
        )
      ) : null}
    </div>
  )
}
